import React, { useRef, useEffect, useState } from "react";
import { Card, Row, Col, Spinner, Button } from "react-bootstrap";
import Utils from "../../utils/index.js";
import ProgressBar from "react-bootstrap/ProgressBar";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { toast } from "react-toastify";
import { t } from "i18next";
import _ from "lodash";
import DeleteModal from "./DeleteModal";
import moment from "moment";
import CircularProgress from '../../pages/BuildAssistant/CircularProgress.js';

const FileCard = (props) => {
  const {
    file,
    fetchFiles,
    index,
    keys,
    uploadProgress,
    uploadstatus,
    isEditable,
    isProgressVisisble,
  } = props;
    
  const totalSteps = 4;
  const token = Utils.getLocalStorageItem("_t");

  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);
  const [isTimeoutExceeded, setIsTimeoutExceeded] = useState(false);
  const [isFirst, setIsFirst] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const currentUser = JSON.parse(Utils.getLocalStorageItem("currentUser"));
  const Link = ({ id, children, title }) => (
    <OverlayTrigger
      placement="left"
      overlay={<Tooltip id={id}>{title}</Tooltip>}
    >
      <span className="nav-item">{children}</span>
    </OverlayTrigger>
  );
  const startFileProcessing = () => {
    const id = setInterval(fetchFiles, 3000);
    setIntervalId(id);

    const timeout = setTimeout(() => {
      clearInterval(id);
      setIsFetching(false);
      setIsTimeoutExceeded(true);
      {
        toast.error(t("fileProcessing"));
      }
    }, 60000);

    setTimeoutId(timeout);
  };

  const stopFileProcessing = () => {
    if (intervalId) clearInterval(intervalId);
    if (timeoutId) clearTimeout(timeoutId);
    setIsFetching(false);
  };

  const handleFileStatusChange = (status) => {
    switch (status) {
      case "completed":
        startFileProcessing();
        setIsFetching(true);
        setIsFirst(true);
        break;
      case "Y":
        stopFileProcessing();
        setIsFetching(false);
        if (isFirst) {
          toast.success(t("fileProcessingSuccess"));
          setIsFirst(false);
        }
        break;
      case "E":
        stopFileProcessing();
        setIsFetching(false);
        if (isFirst) {
          toast.error(t("fileProcessingFailed"));
          setIsFirst(false);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (file?.status) {
      handleFileStatusChange(file.status);
    }
  }, [file?.status]);

  const deleteFile = async (data, index) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}filehandler/delete`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
          body: JSON.stringify({ key: data?.key }),
        }
      );
      if (!response.ok) {
        console.error("Failed to fetch configuration!");
        return;
      }
      const configData = await response.json();
      if (configData?.statusCode) {
        setIsLoading(false);
        fetchFiles();
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(`${t("somethingWentWrong")}, ${error.message}`);
    }
  };
  const StatusIcon = ({ status, error }) => {
    switch (status) {
      case "Y":
        return (
          <span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="15"
                height="15"
                rx="7.5"
                fill="rgba(18,199,71,1)"
              ></rect>
              <rect
                x="0.5"
                y="0.5"
                width="15"
                height="15"
                rx="7.5"
                stroke="rgba(18,199,71,1)"
              ></rect>
              <path
                d="M11.3307 5.5L6.7474 10.0833L4.66406 8"
                stroke="white"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </span>
        );
      case "E":
        return (
          <Link
            id="t-4"
            title={
              error?.toLowerCase().startsWith("error:")
                ? error
                : "Something went wrong. Please delete the file and try again."
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="red"
              className="bi bi-exclamation-triangle-fill"
              viewBox="0 0 16 16"
            >
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
            </svg>
          </Link>
        );
      default:
        return null;
    }
  };
  const handleClose = () => setShowModal(false);
  return (
    <Card>
      <DeleteModal
        show={showModal}
        handleClose={handleClose}
        deleteFile={deleteFile}
        file={file}
        index={index}
      />
      <Card.Body>
        <div
          className="title-file-uploaded"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div className="d-flex flex-column file-info mb-0">
            <Card.Title className="file-name">
              {file?.[keys?.name]}
              {file?.[keys?.size] &&
                `(${Utils.formatBytes(file?.[keys?.size])})`}
            </Card.Title>
            {file?.status && file?.status === "pending" ? (
              isProgressVisisble && ""
            ) : (
              <span>
                {moment(file.createdAt).format("Do MMMM, YYYY HH:mm a")}
              </span>
            )}
          </div>
          {uploadstatus && file?.status == "N" ? (
            <Spinner animation="border" />
          ) : (
            <span className="d-flex gap-2 align-items-start inof-cons">
              <StatusIcon status={file?.status} error={file?.error} />

                {file?.status == "I" && file?.message && (
                  <span
                  style={{ fontSize: "10px", background: "#f6e160",borderRadius:'1rem', lineHeight:'25px', padding: '0.3125rem 0.625rem' }}
                  >
                    {" "}
                    {/* this is the message showing on ui after the file is uploaded */}
                    {file?.message}
                  </span>
                )}
              {file?.status == "pending" && !isProgressVisisble ? (
                <span className="d-flex align-items-end flex-column gap-2">
                  {/* <Spinner className="spin" animation="border" /> */}
                  <div style={{display:'flex'}}>
                  <span style={{ fontSize: "10px", background: "#f6e160",borderRadius:'1rem', lineHeight:'25px', padding: '0.3125rem 0.625rem' }}>
                  {file.message || `File upload successful. Processing initiated...`}
                  </span>
                   {!file.isProcessed &&
                  <div class="btn-bxc" style={{paddingLeft:'5px'}}><span class="d-flex gap-2 align-items-center">
                    <CircularProgress currentStep={file.step} totalSteps={totalSteps} />
                  </span></div>}
                  </div>
                </span>
              ) : (
                file.status !== "pending" && (
                  <>
                    {file?.status == "N" && (
                      <span style={{ fontSize: "10px", background: "#f6e160",borderRadius:'1rem', lineHeight:'1rem', padding: '0.3125rem 0.625rem' }}>
                        {" "}
                        {file.message || `File upload successful. Processing initiated...`}
                      </span>
                    )}
                      {!file.isProcessed &&
                  <div class="btn-bxc"><span class="d-flex gap-2 align-items-center">
                    <CircularProgress currentStep={file.step} totalSteps={totalSteps} />
                  </span></div>}
                    {isEditable &&
                     <span
                        onClick={() => !isFetching && setShowModal(true)}
                        style={{
                          cursor: isLoading ? "not-allowed" : "pointer",
                          opacity: isLoading ? 0.5 : 1,
                          textAlign: "center",
                        }}
                      >
                        {/* deleteFile(file, index) */}

                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167"
                            stroke="#B42318"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
}
                    {/* {file?.createdBy === currentUser?.emailID ? (
                      <span
                        onClick={() => !isFetching && setShowModal(true)}
                        style={{
                          cursor: isLoading ? "not-allowed" : "pointer",
                          opacity: isLoading ? 0.5 : 1,
                          textAlign: "center",
                        }}
                      >

                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167"
                            stroke="#B42318"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    ) : (
                      <span
                        style={{
                          cursor: "not-allowed",
                          opacity: 0.5,
                          textAlign: "center",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167"
                            stroke="#B42318"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    )} */}
                  </>
                )
              )}
            </span>
          )}
        </div>
        {file?.status && file?.status === "pending"
          ? isProgressVisisble && (
              <div className="d-flex mt-2 gap-2 align-items-center customprogress">
                <ProgressBar
                  now={uploadProgress}
                  //label={`${Math.trunc(uploadProgress)}%`}
                />
                <span className="procount">{`${Math.trunc(
                  uploadProgress
                )}%`}</span>
              </div>
              // <ProgressBar
              // className="customprogress mt-2"
              //   now={uploadProgress}
              //   label={`${Math.trunc(uploadProgress)}%`}
              // />
            )
          : ""}
      </Card.Body>
    </Card>
  );
};

const FileList = (props) => {
  const {
    docList,
    keys = { name: "fileName", size: "fileSize" },
    uploadProgress = 0,
    fetchFiles,
    isProgressVisisble,
    isEditable,
  } = props;
  const [uploadstatus, setUploadStatus] = useState(false);

  const filesEndRef = useRef(null);
  const latestFile = _.sortBy(docList, "createdAt").reverse();
  const statusUpdate = () => {
    fetchFiles();
    setUploadStatus(true);
    setTimeout(() => {
      setUploadStatus(false);
    }, 3000);
  };
  const Link = ({ id, children, title }) => (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={id}>{title}</Tooltip>}
    >
      <span className="nav-item" style={{ float: "right" }}>
        {children}
      </span>
    </OverlayTrigger>
  );
  return (
    <div className="list-filt-uploads">
      {docList.map((file, index) => (
        <Row xs={1} md={1} className="g-4 mb-4" key={index}>
          <Col>
            {
              <FileCard
                file={file}
                fetchFiles={fetchFiles}
                keys={keys}
                uploadProgress={uploadProgress}
                uploadstatus={uploadstatus}
                isEditable={isEditable}
                isProgressVisisble={isProgressVisisble}
              />
            }
          </Col>
        </Row>
      ))}

      {docList.length > 0 && (latestFile[0]?.status !== "N" || latestFile[0]?.status !== "pending") && isEditable ? (
        <Link id="t-1" title="Check status">
          {" "}
          <button
            style={{
              float: "right",
              fontSize: "12px",
              cursor: "pointer",
              marginBottom: "1rem",
            }}
            className="rfresh-btn"
            onClick={() => statusUpdate()}
            disabled={uploadstatus}
          >
            {" "}
            {!uploadstatus ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-arrow-clockwise"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                />
                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
              </svg>
            ) : (
              <Spinner
                animation="border"
                style={{ width: "16px", height: "16px" }}
              />
            )}
          </button>{" "}
        </Link>
      ) : (
        ""
      )}
      <div ref={filesEndRef} />
    </div>
  );
};

export default FileList;
